export default "__VITE_ASSET__CsASLNYB__"